import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodTransfer  {
    _originalTypeClassName = "zERP.BO.GoodTransfer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodTransfer.translate = translateService;
}
this.Id = null;
this.Quantity = null;
this.CostPerUnit = null;
this.Date = null;
this.IsTransferIn = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Quantity:any;
CostPerUnit:any;
Date:any;
IsTransferIn:any;
Stock:any;
GoodTransferTransaction:any;
Opposite:any;
Good:any;
Warehouse:any;
static setStock = ($this, value) => {
var oldValue = $this.Stock;
$this.Stock = value;
if (value != null) {
if (oldValue != null) {
Domain.GoodStock.removeTransfers(oldValue, $this);
}
Domain.GoodStock.addTransfers(value, $this);
}
}
static setGoodTransferTransaction = ($this, value) => {
var oldValue = $this.GoodTransferTransaction;
$this.GoodTransferTransaction = value;
if (value != null) {
if (oldValue != null) {
Domain.GoodTransferTransaction.removeTransfers(oldValue, $this);
}
Domain.GoodTransferTransaction.addTransfers(value, $this);
}
}
static setOpposite = ($this, value) => {
var oldValue = $this.Opposite;
$this.Opposite = value;
if (value != null) {
}
}
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
}
}
static setWarehouse = ($this, value) => {
var oldValue = $this.Warehouse;
$this.Warehouse = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}